import "./Home.scss";
import { changeItemSelection } from "@/helpers/commonHelper.js";
import AdBanner from "@/components/AdManager/AdManagerWidget/AdBanner.vue";

export default {
  name: "Home",
  components: { AdBanner },
  computed: {
    modules() {
      return this.$store.state.modules;
    },
    currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    changeItemSelection
  }
};
